<template>
  <div class="notification">
    <CCard title="Tìm kiếm" class="mb-2">
      <CCardHeader class="pt-1 pb-1">
        <h4>Tìm kiếm</h4>
      </CCardHeader>
      <CCardBody class="pt-1 pb-1">
        <CRow  class="mb-2">
          <CCol sm="3" />
          <CCol sm="4">
              <label  class="mb-1">Trạng thái</label>
              <CSelect
                :options='data_read'
                :value.sync="read_status"
              />
            </CCol>
          <CCol sm="2">
            <label class="mb-0">&nbsp;</label>
            <vs-button
              warn
              square
              class="custom_btn_search"
              @click="getNotification()"
            >
              <i class="bx bx-search"></i>&nbsp;Tìm kiếm</vs-button
            >
          </CCol>
          <CCol sm="3" />
        </CRow>
      </CCardBody>
    </CCard>
    <CCard class="mb-2">
      <vue-good-table
        :columns="columns"
        :rows="data_notification"
        compactMode
        :pagination-options="{
          enabled: true,
          perPageDropdownEnabled: false,
          nextLabel: 'Trang sau',
          prevLabel: 'Trang trước',
          ofLabel: 'của',
          perPage: 50,
        }"
        :line-numbers="false"
        :search-options="{
          enabled: false,
          placeholder: 'Tìm kiếm',
        }"
        :sort-options="{
          enabled: false,
        }"
        :row-style-class="rowStyleClassFn"
      >
        <div slot="emptystate" style="margin-top: 10px; margin-bottom: 10px">
          Không có dữ liệu
        </div>
        <template slot="table-row" slot-scope="props">
          <div v-if="props.column.field === 'action'" class="row center">
            <div v-if="props.row.read === 1">
              <vs-tooltip color="success">
                      <vs-button
                        transparent
                        @click="updateNotification(props.row.id)"
                        success
                        circle
                        icon
                        ><i class="bx bxs-check-circle"></i
                      ></vs-button>
                      <template #tooltip>
                        Đánh dấu là đã đọc
                      </template>
                    </vs-tooltip>
            </div>
          </div>
        </template>
      </vue-good-table>
    </CCard>

  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import ClientFactory from "@/api/ClientFactory";
import { VueGoodTable } from "vue-good-table";
const notificationApi = ClientFactory.get("notifications");

export default {
  components: {
    VueGoodTable,
  },
  data: () => ({
    read_status:-1,
    data_read:[
        {
          value: -1,
          label: "Tất cả",
        },
        {
          value: 2,
          label: "Đã đọc",
        },
        {
          value: 1,
          label: "Chưa đọc",
        },
      ],

    columns: [
      {
        label: "Người gửi",
        field: "full_name_create",
        thClass: "text-center",
        width: "150px",
      },
      {
        label: "Thời gian gửi",
        field: "created_date",
        thClass: "text-center",
        width: "150px",
      },
      {
        label: "Tiêu đề",
        field: "title",
        thClass: "text-center",
      },
      {
        label: "Nội dung thông báo",
        field: "content",
        thClass: "text-center",
      },
      {
        label: "Thao tác",
        field: "action",
        thClass: "text-center",
        width: '90px',
        tdClass: 'text-center',
      },
    ],
    itemsCount:0,
    data_notification:[],
  }),
  created() {
    this.getNotification();
  },
  methods: {
    ...mapActions("ui", ["loading", "closeLoading", "notify"]),

    async getNotification() {
        this.loading(this.$vs);
        const {data} = await notificationApi.getNotification(this.read_status,"");
        console.log(data);
        if (data.status == "success") {
          this.itemsCount = data.data[0].total;
          this.data_notification = data.data[0].notifications;
        } else {
        }
        this.closeLoading();
    },
    async updateNotification(id){
      const {data} = await notificationApi.updateNotification({id:id});
      this.getNotification();
    },
    rowStyleClassFn(row) {
      return row.read ===1 ? 'un-read' : '';
    },
  },
  computed: {
    ...mapState("auth", ["AppActiveUser"]),
  },
};
</script>

<style lang="scss">
.notification {
  table.vgt-table td {
      vertical-align: inherit;
      padding: 0.5em 0.75em 0.5em 0.75em;
  }
  .vgt-responsive {
    overflow-x: inherit;
  }
  .visible {
    visibility: visible !important;
  }
  .un-read td{
    background-color: rgb(231, 247, 231);
    font-weight: bold;
  }
}

</style>
